import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import * as a from "../../apis/store/actions";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../components/loader/loader";
import MUIDataTable from "mui-datatables";
import $ from "jquery";
const columns = [
	{
		name: "id",
		options: {
			display: false,
		},
	},
	{
		name: "name",
		label: "Universities",
		options: {
			filter: true,
			sort: true,
		},
	},
	{
		name: "qs_world_ranking",
		label: "QS World University Rankings",
		options: {
			filter: true,
			sort: true,
		},
	},
	{
		name: "us_news_world_ranking",
		label: "US News Global Universities Rankings",
		options: {
			filter: true,
			sort: true,
		},
	},
	{
		name: "shanghai_ranking",
		label: "ARWU World University Rankings (Shanghai Ranking)",
		options: {
			filter: true,
			sort: true,
		},
	},
	{
		name: "shanghai_ranking",
		label: "TCF Index Ranking",
		options: {
			filter: true,
			sort: true,
		},
	},
];

function CountryUniversitiesRankings(props) {
	const history = useHistory();
	const dispatch = useDispatch();
	const options = {
		filterType: "checkbox",
		selectableRows: false,
		download: false,
		print: false,
		filter: false,

		onRowClick: (rowData, rowMeta) => {
			const instituteName = rowData[1].toLowerCase().replace(/\s+/g, '-');
			const city =rowData[0]; 
			const instituteId = rowData[0];
			
			history.push({
			  pathname: `/university-details/${instituteName}/${city}-${instituteId}/`,
			});
		  },
	};
	const {loading, data, error, success} = useSelector(
		({ apis }) => apis.countryRankingsByID
	);

	useEffect(() => {
		if (props.action==='PUSH'||props.action==='POP'){
			dispatch(a.getCountryRanking((props?.countryDetail?.name).toLowerCase()));
		}
	}, []);
	return (
		<section className="uniRankSec">
			<div className="container">
				<div className="mainContTop">
					{loading ? (
						<h5>
							Searching Best Institutes in {props.countryDetail.name} according
							to International Ranking
						</h5>
					) : success && data?.length ? (
						<h5>
							<span>{data?.length}</span> Best Universities in{" "}
							{props.countryDetail.name} according to International Ranking
						</h5>
					) : (
						"No Record Found"
					)}
				</div>
				<div className="tableWrap">
					<div className="table-responsive">
						{loading ? (
							<LoadingSpinner />
						): loading===false && error ?(
							error
						)  : (
							<MUIDataTable
								data={data}
								columns={columns}
								options={options}
							/>
						)}
					</div>
				</div>
			</div>
		</section>
	);
}

export default CountryUniversitiesRankings;
